module.exports = __webpack_public_path__ + "static/media/model.ecdc916b.png";